import { SelectedStudyAreaModel } from '../../state/predictor-model/predictor-model.state';
import { TerrainRenderingStatus } from '../enums/terrain-rendering-status';
import { TerrainLoadingStatus } from '../enums/terrain-loading-status';
import { StatusMessage } from '../interfaces/status-message';

export class StudyAreaStatusService {

  static getStatusMessage(
    terrainRenderingStatus: TerrainRenderingStatus,
    selectedStudyAreaData: SelectedStudyAreaModel | null,
    demFileLoading: boolean,
    demFileUploadStatus: number,
    terrainLoadingStatus: TerrainLoadingStatus
  ): StatusMessage | null {
    // Handle terrain loading failures
    const failedStatusMessage: StatusMessage | null = this.GetTerrainLoadingFailureMessage(terrainLoadingStatus);
    if (failedStatusMessage) return failedStatusMessage;

    if (!selectedStudyAreaData) return this.statusMessages['noneSelected'];
    if (selectedStudyAreaData?.error) {
      return {
        ...this.statusMessages['studyAreaError'],
        message: selectedStudyAreaData.error ?? 'Error with study area',
      };
    }
    if (demFileLoading && demFileUploadStatus === 100) return this.statusMessages['processingUpload'];
    if (demFileLoading) return this.statusMessages['uploading'];
    if (selectedStudyAreaData.shape && selectedStudyAreaData.terrainId == null) return this.statusMessages['noTerrain'];
    if (!demFileLoading && demFileUploadStatus === 100 && terrainRenderingStatus === TerrainRenderingStatus.Loading) return this.statusMessages['calculatingDEM'];
    if (terrainRenderingStatus !== TerrainRenderingStatus.Rendered && terrainRenderingStatus !== TerrainRenderingStatus.None) return this.statusMessages['rendering'];

    return null;
  }

  public static GetTerrainLoadingFailureMessage(terrainLoadingStatus: TerrainLoadingStatus): StatusMessage | null {
    switch (terrainLoadingStatus) {
      case TerrainLoadingStatus.FailedOnCheckingStatus:
      case TerrainLoadingStatus.FailedOnDownload:
      case TerrainLoadingStatus.FailedOnUpload:
        return this.statusMessages['failedOnCheckingStatus'];
      default:
        return null;
    }
  }

  private static statusMessages: { [key: string]: StatusMessage } = {
    failedOnCheckingStatus: { title: '', icon: 'icon-article', message: 'Please upload DEM again or check DEM file.', showGuide: false, guideLink: '' },
    failedOnDownload: { title: '', icon: 'icon-article', message: 'Please upload DEM again or check DEM file.', showGuide: false, guideLink: '' },
    failedOnUpload: { title: '', icon: 'icon-article', message: 'Please upload DEM again or check DEM file.', showGuide: false, guideLink: '' },
    noneSelected: { title: '', icon: 'icon-article', message: 'Please select a study area in the left panel to begin.', showGuide: false, guideLink: '' },
    studyAreaError: { title: '', icon: 'icon-priority-high', message: '', showGuide: false, guideLink: '' },
    processingUpload: { title: '', icon: 'icon-cloud-upload', message: 'DEM file is processing. Please wait...', showGuide: false, guideLink: '' },
    uploading: { title: '', icon: 'icon-cloud-upload', message: 'DEM file is loading. Please wait...', showGuide: false, guideLink: '' },
    noTerrain: { title: '', icon: 'icon-cloud-upload', message: 'Please upload a DEM file to begin.', showGuide: false, guideLink: '' },
    calculatingDEM: { title: '', icon: 'icon-hourglass-top', message: 'Calculating DEM Properties. Please wait...', showGuide: false, guideLink: '' },
    rendering: { title: '', icon: 'icon-autorenew', message: 'Rendering. Please wait...', showGuide: false, guideLink: '' },
    default: { title: 'Welcome to DebrisFlow Predictor', icon: 'symbol-waving-hand', message: 'Use the side panel to create or select a study area.', showGuide: true, guideLink: '' },
  };

}
